<template>
    <div id="app">
      <header class="header">
        <div class="header-wrap">
          <router-link class="header-icon header-logo" :to="{name: 'intro', params: { filter: 'intro' }}">
            <img src="/static/imgs/icons/logo.svg">
          </router-link>
          <a @click="toggleMenu" class="header-nav-toggle header-nav-button">MENU</a>
          <nav @click="toggleMenu" class="header-nav" v-bind:class="{ open : menu }">
            <router-link class="header-nav-button" :to="{name: 'the-magic', params: { filter: 'the-magic' }}">The Magic</router-link>
            <router-link class="header-nav-button" :to="{name: 'master-pieces', params: { filter: 'master-pieces' }}">Master Pieces</router-link>
            <router-link class="header-nav-button" :to="{name: 'dioramas', params: { filter: 'dioramas' }}">Dioramas</router-link>
            <router-link class="header-nav-button" :to="{name: 'manufacturers', params: { filter: 'manufacturers' }}">Manufacturers</router-link>
            <router-link class="header-nav-button" :to="{name: 'materials', params: { filter: 'materials' }}">Materials</router-link>
            <router-link class="header-nav-button" :to="{name: 'boxes-and-scales', params: { filter: 'boxes-and-scales' }}">Boxes and Scales</router-link>
            <router-link class="header-nav-button" :to="{name: 'model-history', params: { filter: 'model-history' }}">E-Type History</router-link>
          </nav>
          <router-link @click="toggleMenu" :to="{name: 'search'}" class="header-icon header-search">
            <img src="/static/imgs/icons/search.svg">
          </router-link>
        </div>
      </header>
      <main>
         <span v-if="preloading">preload</span>

        <router-view></router-view>
        <footer class="footer">
          <div class="footer-wrap">
            <a target="_blank" href="https://www.instagram.com/etypecorner/" class="footer-insta">
              <img src="./assets/imgs/icons/instagram.svg">
            </a>
            <span class="footer-credits">© 2017 all rights reserved to E-Type Corner</span>
            <a href="mailto:etypecorner@gmail.com" target="_blank" class="footer-contact">
              <img src="./assets/imgs/icons/envelope.svg">
            </a>
          </div>
        </footer>
      </main>
    </div>
</template>

<script>
export default {
  name: 'app',
  data: function () {
    return {
      menu: false,
      preloading: true
    }
  },
  methods: {
    toggleMenu: function () {
      if (this.menu === false) {
        this.menu = true
      } else {
        this.menu = false
      }
    },
    doneLoading: function () {
      this.preloading = false
    }
  },
  mounted () {
    this.doneLoading()
  }
}
</script>

<style>
  @import "https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css";
</style>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Old+Standard+TT:400i|Open+Sans:300,400,600,700,800&subset=latin-ext');
  
  $white: #FFFFFF;
  $bar-grey: rgba(48, 48, 42, 1);
  $intro-grey: #30312A;
  
  body {
      font-family: 'Open Sans', sans-serif;
  }
  
  .header {
      height: 60px;
      width: 100%;
      position: fixed;
      left: 0;
      top: 0;
      z-index: 999;
      background-color: $bar-grey;
      border-bottom: 4px solid white;
      
      &-wrap {
          margin: 0 auto;
          max-width: 980px;
          height: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
      }
      &-nav {
          &-toggle {
              display: none;
              cursor: pointer;
          }
          &-button {
              padding: 0 10px;
              color: $white;
              transition: color 0.4s ease 0s;
              font-size: 13px;
              font-weight: 100;
  
              
              &:hover, &:focus {
                  color: #D4D4D4;
                  text-decoration: none;
              }
              &.router-link-active {
                  color: #797979;
              }
          }
      }
      &-icon {
          color: $white;
          padding: 0 10px;
          width: 50px;
          transition: 1s;
          &:hover {
            opacity: 0.6;
          }
      }
      &-search {
        padding: 0;
        img {
          width: 45px;
        }
      }
  }
  
  main {
      min-height: calc(100% - 120px);
      width: 100%;
      position: absolute;
      left: 0;
      top: 60px;
      background-color: $white;

      .carousel-fade {
          .carousel-inner {
              .item {
                  transition-property: opacity;
              }
              
              .item,
              .active.left,
              .active.right {
                  opacity: 0;
              }
      
              .active,
              .next.left,
              .prev.right {
                  opacity: 1;
              }
      
              .next,
              .prev,
              .active.left,
              .active.right {
                  left: 0;
                  transform: translate3d(0, 0, 0);
              }
          }
      
          .carousel-control {
              z-index: 2;
          }
      }
      .carousel, 
      .carousel-inner, 
      .carousel-inner .item {
          height: 100%;
      }
      .carousel {

          &-preload {
            min-height: calc(100vh - 120px);
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              max-width: 180px;
            }
          }

          .item {
              background-size: cover;
              background-position: center;
              background-repeat: no-repeat;
              background-color: #F0F5F8;
  
              &-capa {
                  background-color: $bar-grey;
                  // animation: capaFadeIn 1s forwards;

                  &.active {
                      opacity: 1;
                  }
                  .item-content--counter {
                      display: none;
                  }
              }
              &-content {
                  text-align: center;
                  color: white;
                  height: 100%;
                  position: relative;
                  padding-top: 40px;
                  min-height: calc(100vh - 120px);
                  &.black {
                      color: $bar-grey;
                      .item-content--icon {
                      }
                  }
                  &--icon {
                      margin: 0 auto;
                      padding-bottom: 5px;
                      position: relative;
                      z-index: 90;
                      width: 30px;
                      &-wrapper {
                        min-height: 38px;
                      }
                  }
                  &--title {
                      font-size: 26px;
                      font-family: 'Old Standard TT', serif;
                      font-style: italic;
                      margin: 20px 0 8px 0;
                      position: relative;
                      z-index: 90;
                  }
                  &--desc {
                      font-size: 14px;
                      margin: 0;
                      position: relative;
                      z-index: 90;
                  }
                  &--counter {
                      position: absolute;
                      bottom: 30px;
                      left: 50%;
                      margin-left: -25px;
                      width: 50px;
                  }
                  &--longtext {
                      font-size: 14px;
                      line-height: 22px;
                      max-width: 740px;
                      padding: 0 20px;
                      margin: 30px auto 0 auto;
                      font-weight: 100;
                      img {
                            max-width: 200px;
                      }
                  }
                  &--shorttext {
                      margin: 90px auto;
                      font-size: 40px;
                      overflow: hidden;
                      font-weight: 500;
                      white-space: nowrap;
                      min-height: 60px;
                      &-wrapper {
                        height: 100%;
                        position: absolute;
                        width: 86%;
                        top: 0;
                        left: 50%;
                        margin-left: -43%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                  }
                  &--model {
                    margin-top: 20px;
                    width: 100%;
                  }
                  &--boxes {
                      display: flex;
                      width: 100%;
                      flex-wrap: wrap;
                      margin-top: 20px;
                      justify-content: center;
  
                  }
                  &--box {
                      width: 255px;
                      height: 175px;
                      border: 2px solid transparent;
                      cursor: pointer;
                      background-position: center;
                      background-size: cover;
                      margin: 2px;
                      img {
                          width: 100%;
                          opacity: 0;
                      }
                  }
              }            
          }
          &-control {
              position: absolute;
              z-index: 999;
              top: 50%;
              margin-top: -25px;
              width: 90px;
              height: 90px;
              border: 0px;
              background: none !important;
              padding: 0;
              opacity: 0.8;
      
              &.left {
                  left: 10px;
              }
              &.right {
                  right: 10px;
              }            
          }
      }
  
      .homepage {
          display: flex;
          // flex-wrap: wrap;
          height: 100%;
          &-car {
              position: absolute;
              width: 340px;
              top: 50%;
              left: 50%;
              margin-left: -165px;
              margin-top: -135px;
          }
          &-left {
              width: 45%;
              min-height: calc(100vh - 120px);
              display: flex;
              flex-direction: column;
              position: relative;
              &--top {
                  height: 50%;
                  color: #101E8E;
                  text-align: center;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  padding-top: 20px;
                  font-size: 12px;
                  .homepage-count {
                      font-size: 35px;
                      display: block;
                  }
              }
              &--bottom {
                  background: #F2F2F2;
                  height: 50%;
                  text-align: center;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: flex-end;
                  padding: 0 30px 20px 30px;
                  h4 {
                      color: #101E8E;
                      font-size: 12px;
                      margin: 5px 0;
                  }
                  h3 {
                      margin: 5px 0 10px;
                      font-size: 10px;
                  }
                  p {
                      font-size: 12px;
                  }
                  a {
                      color: black;
                      border: 1px solid black;
                      font-size: 10px;
                      display: block;
                      padding: 5px 15px;
                  }
              }
          }
          &-right {
              display: flex;
              flex-wrap: wrap;
              width: 55%;
              &-item {
                  width: 50%;
                  height: calc(50vh - 60px);
                  background-position: center;
                  background-size: cover;
                  position: relative;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  
                  &--desc {
                      position: absolute;
                      bottom: 0;
                      left: 0;
                      color: black;
                      width: 100%;
                      height: 40px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      background: rgba(255,255,255,0.4);
                      transition: 0.3s linear;
                  }
                  
                  &:hover {
                      .homepage-right-item--desc {
                          background: rgba(255,255,255,0.6);
                      }
                  }
                  
                  &:nth-child(4) {
                      a {
                        width: 100%;
                        height: 100%;
                        overflow: hidden;
                        text-align: center;
                        display: flex;
                        justify-content: center;
                        video {
                          height: 100%;
                        }
                      }
                      img {
                        width: 100%;
                      }
                  }

              }
          }
      }
      
      
  }
  
  #vue-lightbox {
    width: 100% !important;
    height: 100% !important;
    left: auto !important;
    top: auto !important;

    .lb-outerContainer {
      background: transparent;
      width: 100% !important;
      height: 100% !important;
      display: flex;
      justify-content: center;
      align-items: center;
      max-width: 2560px;


      .lb-container {
        padding: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
    
        img {
          border: 0px;
          width: 100% !important;
          height: auto !important;
          display: block !important;
        }
      }
    }
    .lb-dataContainer {
      position: absolute;
      top: 0px;
      right: 20px;
      a {
        width: 25px;
        height: 25px;
        background-size: 100%;
        opacity: 1;
      }
    }
  }
  
  // MAIN EXCEPÇOES
  
  .carousel.boxes-and-scales, .carousel.model-history{
    .item-capa {
      background-color: #E0EEF4;
      }  
  } 
  
  .carousel.intro {
    .item-capa {
      .item-content--icon {
        opacity: 0;
      }
    }
  }
  
  .carousel.model-history {
    .item-content--shorttext {
      width: 0;
      animation: shorttext 6s forwards;
      animation-delay: 2s;
      
    }
  }

  .carousel.the-magic {
    .item-capa {
      .item-content--longtext {
        img {
          max-width: 120px;
        }
      }
    }
  }
  
  .carousel.boxes-and-scales {
    .item-slide {
      background-color: #E0EEF4;
      }  
      
  }
  
  .footer {
      height: 60px;
      width: 100%;
      position: static;
      z-index: 999;
      left: 0;
      bottom: 0;
      background-color: $bar-grey;
      border-top: 4px solid white;
  
      &-wrap {
          margin: 0 auto;
          max-width: 980px;
          height: 100%;
          color: $white;
          font-size: 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
      }
      &-insta, &-contact {
          color: $white;
          padding: 0 10px;
          transition: 0.8s;
          &:hover {
            opacity: 0.6;
          }
          img {
              width: 20px;
          }
      }
  }
  
  @media screen and (max-width: 768px) {
      .header {
        height: 45px;
          &-nav {
              // display: none;
              width: 100%;
              position: fixed;
              top: 45px;
              left: 0;
              z-index: 999;
              background: $bar-grey;
              text-align: center;
              padding: 5px 0 15px 0;
              visibility:hidden;
              opacity:0;
              transition:visibility 0.3s linear,opacity 0.3s linear;
              &.open {
                  visibility:visible;
                  opacity:1;
              }
              &-button {
                  width: 100%;
                  display: block;
                  padding: 14px 0;
                  font-size: 16px;
              }
              &-toggle {
                  width: auto;
                  display: block;
              }
          }
      }
      main {
          top: 45px;
          .carousel {
            
              .item {
                  &-content {
                      padding-top: 20px;
                      min-height: calc(100vh - 90px);
                  
                      &--longtext {
                          max-width: 85%;
                      }
                      &--shorttext {
                        font-size: 25px;
                        min-height: 90px;
                        white-space: initial;
                      }
                  }
              }
              
              &-control {
                  width: 60px;
                  height: 60px;
                  position: fixed;
                  
                  &.left {
                      left: 0px;
                  }
                  &.right {
                      right: 0px;
                  }
              }
          }
          .homepage {
              display: block;
              &-left {
                  width: 100%;
                  height: 555px;
                  min-height: auto;
                  .homepage-car {
                    width: 40vh;
                    margin-left: -20vh;
                    margin-top: -120px;
                  }
              }
              &-right {
                  width: 100%;
                  min-height: auto;
                  &-item {
                      width: 50vw;
                      height: 50vw;
                      img {
                      }
                  }
              }
          }

      }
      .footer {
        height: 45px;
      }
  } 
  
@keyframes shorttext {
    from {width: 0;}
    to {width: 85%;}
}

@keyframes capaFadeIn {
    from {opacity: 0.9;}
    to {opacity: 1;}
}

</style>



// WEBPACK FOOTER //
// App.vue?ff51be7c